import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2, MailCheck, Send } from "lucide-react";
import { AuthShell, inputCls, primaryBtnCls } from "@/components/AuthShell";
import { errMsg, http } from "@/lib/api";
import { usePageTitle } from "@/lib/hooks";

export default function ForgotPasswordPage() {
  usePageTitle("Forgot Password");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell onSubmit={submit} testId="forgot-password-form" title="Forgot password"
      subtitle="Enter the admin email. A reset link goes to the PRICEHUB recovery inbox.">
      {sent ? (
        <div className="mt-8 rounded-2xl bg-ph-lime/15 px-5 py-4 text-sm text-ph-ink" data-testid="forgot-password-sent">
          <p className="flex items-center gap-2 font-semibold"><MailCheck className="h-4 w-4" /> Check the recovery inbox</p>
          <p className="mt-1">If that email belongs to an admin, a reset link is on its way. It works once and expires in 15 minutes.</p>
        </div>
      ) : (
        <>
          <label className="mt-8 block text-sm font-medium text-ph-ink/85" htmlFor="forgot-email">Admin email</label>
          <input id="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username"
            data-testid="forgot-password-email" className={inputCls} />
          {error && <p className="mt-4 rounded-xl bg-red-500/10 px-4 py-3 text-sm text-red-600" data-testid="forgot-password-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="forgot-password-submit" className={primaryBtnCls}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Email me a reset link
          </button>
        </>
      )}
      <Link to="/admin/login" data-testid="forgot-password-back" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-ph-muted hover:text-ph-accent">
        <ArrowLeft className="h-4 w-4" /> Back to sign in
      </Link>
    </AuthShell>
  );
}
